import styled from 'styled-components';

import { Modal } from '@speeki/global-ui-components';

export const ModalTitle = styled(Modal.TitleSecondary)`
    margin-bottom: 16px;
`;

export const ModalDescription = styled(Modal.Description)`
    margin-bottom: 24px;
`;

export const ModalList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
`;
